export default __webpack_public_path__ + "static/media/skyniche-logo-footer.81aec7fb.png";